module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600.woff2?9526470852428b4340ed994462821463";